import { ErrorPage } from "@/LoginPage";
import { FeatureFlagsQuery } from "@/gql/graphql";
import { useQuery } from "@apollo/client";
import { gql } from "@apollo/client";
import React, {
  PropsWithChildren,
  createContext,
  useEffect,
  useState,
} from "react";

const featureFlagsQuery = gql`
  query FeatureFlags {
    productPrice {
      features {
        agreement {
          useReportMessageSubscription
        }
      }
    }
  }
`;

export interface FeatureFlags {
  agreement: {
    useReportMessageSubscription: boolean;
  };
}

export interface FeatureFlagsContextType {
  featureFlags: FeatureFlags;
  setFeatureFlags: React.Dispatch<React.SetStateAction<FeatureFlags>>;
}

const FeatureFlagsContext = createContext<FeatureFlagsContextType | null>(null);

const FeatureFlagsProvider = ({ children }: PropsWithChildren<{}>) => {
  const { data, error } = useQuery<FeatureFlagsQuery>(featureFlagsQuery);

  const [featureFlags, setFeatureFlags] = useState<FeatureFlags>({
    agreement: { useReportMessageSubscription: false },
  });

  useEffect(() => {
    if (data) {
      setFeatureFlags(data.productPrice.features);
    }
  }, [data, setFeatureFlags]);

  if (error) {
    return <ErrorPage text={error.message} />;
  }

  return (
    <FeatureFlagsContext.Provider
      value={{
        featureFlags,
        setFeatureFlags,
      }}
    >
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export { FeatureFlagsContext, FeatureFlagsProvider };
